import TemplateDetailAdapter from '@domains/subscription/priv/adapters/TemplateDetailAdapter'
import { useNavigate, useParams } from 'react-router'

export const TemplateDetailPage = () => {
  const { templateId = '' } = useParams<'templateId'>()
  const navigate = useNavigate()

  const navigateToSubscriptionPlan = () => {
    navigate(`/subscription`)
  }

  return <TemplateDetailAdapter navigateBack={navigateToSubscriptionPlan} templateId={templateId} />
}
